'use client';

import {
  AskUserAnswerCardView,
  readAskUserAnswer,
  readAskUserPrompt,
} from '../../components/tools/ask-user/ask-user-answer-card-view';
import type { TraceToolCall } from '../types';

type TraceAskUserToolCardProps = {
  toolCall: TraceToolCall;
};

export function TraceAskUserToolCard({ toolCall }: TraceAskUserToolCardProps) {
  if (toolCall.status !== 'completed') {
    return null;
  }

  const prompt = readAskUserPrompt(toolCall.args);
  const { answer, skipped, answerMentions, answerSegments } = readAskUserAnswer(
    toolCall.output,
  );

  return (
    <AskUserAnswerCardView
      prompt={prompt}
      answer={answer}
      skipped={skipped}
      answerMentions={answerMentions}
      answerSegments={answerSegments}
    />
  );
}
